'use es6';

import { DropTarget } from 'react-dnd';
import { throttle } from 'underscore';
import ReactDOM from 'react-dom';
const SCROLL_MARGIN = 20;
const SCROLL_SPEED = 20;
const THROTTLE_TIMEOUT = 30;

const onHover = (monitor, component) => {
  const clientOffset = monitor.getClientOffset();

  if (clientOffset) {
    const componentDOM = ReactDOM.findDOMNode(component);
    const {
      y: cursorVerticalPosition
    } = clientOffset;
    const {
      top,
      bottom
    } = componentDOM.getBoundingClientRect();

    if (cursorVerticalPosition - top < SCROLL_MARGIN) {
      componentDOM.scrollTop -= SCROLL_SPEED;
    } else if (bottom - cursorVerticalPosition < SCROLL_MARGIN) {
      componentDOM.scrollTop += SCROLL_SPEED;
    }
  }
};

const throttledOnHover = throttle(onHover, THROTTLE_TIMEOUT);
/**
 * Makes react drag and drop elements scrollable, meant to be a fix for IE and Safari
 * related drag and drop scrolling issues
 */

export default function withScrollDropTargets(dndItemTypes) {
  const scrollDropTargetOptions = {
    canDrop() {
      return false;
    },

    hover(props, monitor, component) {
      throttledOnHover(monitor, component);
    }

  };

  const scrollDropTargetProps = connect => {
    return {
      connectDropTarget: connect.dropTarget()
    };
  };

  return WrappedComponent => {
    return DropTarget(dndItemTypes, scrollDropTargetOptions, scrollDropTargetProps)(WrappedComponent);
  };
}